import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  useStarredStatusQuery,
  useToggleStarredWorkerMutation,
} from "@/queries/hooks/starredWorkerHooks";
import { useRole } from "@/utils/hooks/use-role";

export function StarButton({
  workerId,
  workerName,
}: {
  workerId: string;
  workerName?: string | null;
}) {
  const { t } = useTranslation("profile");
  const role = useRole();
  const { data: starred } = useStarredStatusQuery(
    role === "employer" ? workerId : undefined,
  );
  const toggle = useToggleStarredWorkerMutation(workerId);

  if (role !== "employer") return null;

  const isStarred = !!starred;
  const aria = isStarred
    ? t("worker.unstarAria", { name: workerName ?? "" })
    : t("worker.starAria", { name: workerName ?? "" });

  return (
    <button
      type="button"
      aria-label={aria}
      aria-pressed={isStarred}
      disabled={toggle.isPending}
      onClick={() => toggle.mutate(!isStarred)}
      className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-ember/40 bg-white hover:bg-fog transition disabled:opacity-50"
    >
      <Star
        className="w-5 h-5 text-ember"
        fill={isStarred ? "currentColor" : "none"}
      />
    </button>
  );
}
